

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ICommunicationMessage} from "@/model/Communication/ICommunicationMessage";
import OrderChip from "@/components/shared/chips/OrderChip.vue";
import Datim from "@/components/shared/Datim.vue";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

@Component({
  components: {
    OrderChip,
    Datim
  }
})
export default class CommunicationMessages extends Vue {

  @Prop()
  protected loading!: boolean;
  @Prop()
  protected items!: ICommunicationMessage[];
  @Prop({default: true})
  protected showOrderChip!: boolean;
  @Prop({ default: null })
  protected timezone!: string | null;

  protected messageDetailsShowing: boolean = false;
  protected currentMessage: ICommunicationMessage|null = null;

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('orders.order.communications.createdAt'), align: 'center', sortable: false, value: 'created_at' },
      // { text: this.$t('orders.order.communications.to'), align: 'start', sortable: false, value: 'to' },
      // { text: this.$t('orders.order.communications.type'), align: 'center', sortable: false, value: 'type' },
      { text: this.$t('orders.order.communications.content'), align: 'start', sortable: false, value: 'content' },
      { text: this.$t('orders.order.title'), align: 'center', sortable: false, value: 'order_id' },
      { text: this.$t('orders.order.communications.status'), align: 'center', sortable: false, value: 'status' },
    ];
  }

  protected get getHeaders(): any {
    return this.headers
        .filter((i: any) => {
          switch (i.value) {
            case 'order_id': return !this.showOrderChip;
            case 'to': return this.showOrderChip;
            default: return true;
          }
        });
  }

  protected typeIcon(item: ICommunicationMessage): string {
    if (item.type === 'sms') {
      return this.$icons.communications.type.sms;
    }
    else if (item.type === 'email') {
      return this.$icons.communications.type.email;
    }
    return '';
  }

  protected onMessageClicked(message: any) {
    this.currentMessage = message;
    this.messageDetailsShowing = true;
  }

}

